import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "editor-divider-16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { stroke: "currentColor", strokeWidth: 1.5, fill: "none", fillRule: "evenodd", strokeLinecap: "round" },
        React.createElement("path", { strokeOpacity: 0.15, d: "M2.75 3.75h10.5" }),
        React.createElement("path", { d: "M2.75 7.75h10.5" }),
        React.createElement("path", { strokeOpacity: 0.15, d: "M2.75 11.75h10.5" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
